import { render, staticRenderFns } from "./ship-error.vue?vue&type=template&id=1bd9de82&scoped=true"
import script from "./ship-error.vue?vue&type=script&lang=js"
export * from "./ship-error.vue?vue&type=script&lang=js"
import style0 from "./ship-error.vue?vue&type=style&index=0&id=1bd9de82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9de82",
  null
  
)

export default component.exports